import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/standard-quality-control-concept-m_23-2150041860.jpg';

function DataSecurityPrivacy() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Data Security and Privacy Management" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Data Security and Privacy Management</h4>
              <p>
                This sub-department is dedicated to safeguarding public information and ensuring data privacy across governmental operations.<br />
                Programs include implementing robust cybersecurity measures, conducting regular audits, and educating staff on data protection protocols.<br /><br />
                Our objective is to build trust by maintaining the confidentiality, integrity, and availability of sensitive data.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Comprehensive Cybersecurity Policies</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Data Privacy Audits and Assessments</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Training and Awareness Programs</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to protecting sensitive data and ensuring that privacy standards are upheld, fostering public trust in digital governance.
              </p>
            </div>
            <div>
              <Link to="/department/technology">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default DataSecurityPrivacy;
